export default import.meta.ROLLUP_FILE_URL_FHj5jD_6QJWS0gFDtIh7lw